<!-- <button type="button" class="{{class}}" (click)="onCallbutton()"><i class="fa fa-phone"></i></button> -->
<i class="pi pi-phone phone-icon-comp"  (click)="onCallbutton()"></i>
